/* GDJ collection & search results — self-hosted search engine.
 * Replaces the former Algolia InstantSearch. Renders into the SAME containers
 * (#gdj-facet-*, #gdj-acoll-hits, sort, current, clear) with the same .ais-* /
 * .gdj-card--list markup, so the existing CSS + card design are unchanged.
 * Faceting, sorting, pagination (infinite scroll) all run against /api/v1/search. */
(function () {
  "use strict";
  // One instance per .gdj-acoll root: collection/search pages have one, a landing
  // page may have several. The <script> tag is rendered once per grid, so guard
  // against double initialization.
  function initGrid(root) {
  if (root.dataset.gdjInit === "1") return;
  root.dataset.gdjInit = "1";
  const d = root.dataset;
  const API = (d.searchApiUrl || "").replace(/\/$/, "");
  const SHOP = d.shop;
  if (!API || !SHOP) return;

  const LOCALE = (d.locale || "fr").slice(0, 2);
  const MONEY = d.moneyFormat || "{{amount}} €";
  const SHOW_RATINGS = d.showRatings === "true";
  const SEARCH_MODE = d.searchMode === "1";
  const COLLECTION_GID = d.collectionGid || "";       // gid of the current collection (collection pages)
  const CATEGORY = d.category || "";                    // pre-selected product_type (cat- collections)
  const QUERY0 = SEARCH_MODE ? (d.query || "") : "";
  const CUSTOMER_ID = d.customerId || "";
  const L = safeJson(d.labels, {});
  // Landing pages (snippets/gdj-landing-products.liquid): filters fixed by the
  // editor, products pinned first, products excluded. Empty on collection/search pages.
  const IS_LANDING = d.mode === "landing";
  const LOCKED = safeJson(d.lockedFilters, {});
  const PINNED = safeJson(d.pinnedIds, []).map(String);
  const EXCLUDED = safeJson(d.excludedIds, []).map(String);
  let pinnedCache = null;
  // A landing block whose FIRST load is empty disappears. Later empty results come from the
  // shopper's own filters and must keep the block (its filters, « Tout effacer ») on screen.
  let firstLoad = true;
  function hideGrid() { openDrawer(false); root.hidden = true; }
  // Which metafield key feeds each fixed facet container.
  const FMAP = safeJson(d.facetMap, {
    vendor: "custom.brand", theme: "custom.theme_fr",
    players: "custom.players", age: "custom.age_recommendation",
  });
  const root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  // Optional hard filter from the URL: /search?q=…&must=extension keeps only
  // results whose title contains every "must" token. Used by the fiche's
  // "voir toutes les extensions" links so unrelated products stay out.
  const fold = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  const SCOPE_TYPE = (() => {
    try { return new URLSearchParams(location.search).get("ptype") || ""; }
    catch (_) { return ""; }
  })();

  const MUST = (() => {
    try { return fold(new URLSearchParams(location.search).get("must")).split(/\s+/).filter(Boolean); }
    catch (_) { return []; }
  })();
  const passesMust = (p) => !MUST.length || MUST.every((w) => fold(p.title).includes(w));

  const SID_KEY = "gdj_search_session";
  let sessionId = localStorage.getItem(SID_KEY);
  if (!sessionId) { sessionId = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(SID_KEY, sessionId); }

  // Search-history panel writer (assets/gdj-search-autocomplete.js reads this
  // key). The header autocomplete's own submit handler covers searches
  // initiated from its panel; this covers a query landed on directly (typed
  // URL, browser back/forward, a link with ?q=).
  if (SEARCH_MODE && QUERY0 && QUERY0.trim()) {
    try {
      const KEY = "gdj_recent_searches";
      const raw = localStorage.getItem(KEY);
      let list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) list = [];
      const q = QUERY0.trim();
      const lower = q.toLowerCase();
      list = list.filter((item) => item && String(item.q || "").toLowerCase() !== lower);
      list.unshift({ q, t: Date.now() });
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 5)));
    } catch (_) {}
  }

  const PER_PAGE = 24;
  const state = {
    q: QUERY0,
    // Searches sort by relevance; collections default to best sellers
    // (En vedette was removed — meaningless without a query), with
    // per-collection overrides (nouveautes → newest).
    sort: d.defaultSort || (SEARCH_MODE ? "featured" : "best_sellers"),
    page: 1,
    total: 0,
    loading: false,
    done: false,
    list: {},      // metafield_key -> [values]
    sliders: {},   // metafield_key -> {min,max}
    price: null,   // {min,max}
    // ?ptype= lets a typeahead suggestion say WHERE it searches ("dans Jeux de
    // societe") and have the search page honour it, shown as a removable pill
    // like any other type filter.
    type: SCOPE_TYPE ? [SCOPE_TYPE] : (CATEGORY ? [CATEGORY] : []),
    brand: [],     // engine-native brand facet (__brand)
    facets: null,  // last engine facet payload
  };

  function safeJson(s, fb) { try { return JSON.parse(s); } catch (_) { return fb; } }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])); }
  function el(id) { return root.querySelector("#" + id); }
  function fmtMoney(v) {
    const n = Number(v); if (!isFinite(n)) return "";
    const a = n.toFixed(2), nd = Math.round(n).toString();
    return MONEY.replace(/\{\{\s*amount\s*\}\}/g, a)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, nd)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, nd);
  }
  const numId = (gid) => String(gid || "").split("/").pop();

  function beacon(path, body) {
    const payload = JSON.stringify(body);
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}${path}`, new Blob([payload], { type: "text/plain;charset=UTF-8" }));
        return;
      }
    } catch (_) { /* fall through to fetch */ }
    fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
  }

  function trackView(pid) {
    // Loi 25 / consent gate: personalization events only after explicit opt-in.
    if (!window.gdjConsent || window.gdjConsent.allowed() !== true) return;
    // Position and the list this click came from are what turn clicks into
    // training data: without them a model cannot tell a good product from one
    // that merely sat in the top slot.
    const pos = impressionPos.get(String(pid));
    beacon("/api/v1/events", {
      shop: SHOP, session_id: sessionId, customer_id: CUSTOMER_ID || null,
      events: [{
        type: "view",
        product_id: pid,
        query: state.q || "",
        metadata: { position: pos || null, event_id: impressionId, surface: SEARCH_MODE ? "search" : "collection" },
      }],
    });
  }

  // --- Impressions: what was SHOWN, in the order shown ----------------------
  // Clicks alone cannot train a ranker — they say what people chose, never what
  // they saw and skipped. One beacon per rendered page, ids in display order.
  let impressionId = "";
  const impressionPos = new Map();   // product id -> 1-based position in the list

  function newImpressionId() {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function trackImpressions(products, reset) {
    if (!products.length) return;
    if (reset) { impressionId = newImpressionId(); impressionPos.clear(); }
    const offset = impressionPos.size;
    products.forEach((p, i) => impressionPos.set(numId(p.id), offset + i + 1));
    if (!window.gdjConsent || window.gdjConsent.allowed() !== true) return;
    beacon("/api/v1/impressions", {
      shop: SHOP,
      event_id: impressionId,
      session_id: sessionId,
      customer_id: CUSTOMER_ID || null,
      surface: SEARCH_MODE ? "search" : "collection",
      q: state.q || "",
      filters: buildFilters(),
      sort: state.sort,
      page: state.page,
      results_total: state.total,
      product_ids: products.map((p) => numId(p.id)),
    });
  }

  // ---------------- fetch ----------------
  function buildFilters() {
    const f = {};
    Object.entries(state.list).forEach(([k, v]) => { if (v && v.length) f[k] = v; });
    Object.entries(state.sliders).forEach(([k, v]) => { if (v) f[k] = v; });
    if (state.type.length) f.__product_type = state.type;
    if (state.brand.length) f.__brand = state.brand;
    if (state.price) f.__price = state.price;
    if (COLLECTION_GID) f.__collection = [COLLECTION_GID];
    if (MUST.length) f.__title_must = MUST;  // engine filters products AND facets
    Object.assign(f, LOCKED);           // the editor's filters win over a shopper's pick on the same key
    const ex = EXCLUDED.concat(PINNED); // pinned products are rendered separately, never twice
    if (ex.length) f.__exclude_ids = ex;
    return f;
  }

  // Visible feedback for every async load: dim the grid + spin.
  function setBusy(on) {
    const hits = el("gdj-acoll-hits");
    if (hits) hits.classList.toggle("is-loading", !!on);
    const spin = root.querySelector(".gdj-acoll__spinner");
    if (spin) spin.hidden = !on;
    if (moreBtn) moreBtn.classList.toggle("is-loading", !!on);
  }

  async function fetchPinned() {
    if (pinnedCache) return pinnedCache;
    try {
      const res = await fetch(`${API}/api/v1/products/by-ids`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: SHOP, ids: PINNED }),
      });
      pinnedCache = (await res.json()).products || [];
    } catch (e) {
      console.error("[gdj-search] pinned fetch failed", e);
      pinnedCache = [];
    }
    return pinnedCache;
  }

  async function fetchPage(reset) {
    if (state.loading) return;
    if (reset) { state.page = 1; state.done = false; }
    if (state.done) return;
    state.loading = true;
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/v1/search`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: SHOP, q: state.q, locale: LOCALE, filters: buildFilters(), sort: state.sort, page: state.page, limit: PER_PAGE, session_id: sessionId, disable_auto_facets: !!state.noAutoFacets }),
      });
      const data = await res.json();
      const raw = data.products || [];
      const products = raw.filter(passesMust); // safety net; engine already applies __title_must
      state.total = Math.max(0, (data.total || 0) - (raw.length - products.length));
      state.facets = data;
      // Filters the engine inferred from the typed words, so the chip row can
      // show them. Skipped once the shopper has dismissed them.
      state.autoFilters = state.noAutoFacets ? [] : (data.auto_filters || []);
      // Landing pages: pinned products open page 1 and count in the total on every
      // page (state.total is recomputed from data.total on each fetch; the engine
      // already leaves them out through __exclude_ids). fetchPinned() is cached.
      const pins = PINNED.length ? await fetchPinned() : [];
      state.total += pins.length;
      if (reset) el("gdj-acoll-hits").innerHTML = "";
      const hits = reset ? pins.concat(products) : products;
      appendHits(hits);
      // A landing block with nothing to show disappears instead of saying "no results".
      if (IS_LANDING && reset && !hits.length && firstLoad) hideGrid();
      firstLoad = false;
      if (state.page * PER_PAGE >= (data.total || 0) || raw.length === 0) state.done = true;
      // Shopify puts ITS OWN result count in the page title ("839 résultats"),
      // counted by its native search — a different engine over a different index
      // from the one that produced what is on screen. Reconcile it with ours so
      // the tab and the page stop disagreeing.
      if (SEARCH_MODE && reset && document.title) {
        // Match a grouped number ("839", "1 873") without eating the space that
        // follows it — the separator only counts when three digits follow.
        const shown = state.total.toLocaleString(document.documentElement.lang || "fr-CA");
        const retitled = document.title.replace(/\d+(?:[\s .,]\d{3})*/, shown);
        if (retitled !== document.title) document.title = retitled;
      }
      trackImpressions(products, reset);
      if (reset) renderFacets(data);   // rebuild facets only on a fresh query (keeps slider drag smooth)
      if (reset) renderPickupBand(products);   // never awaited: results are already on screen
      renderToolbar();
    } catch (e) {
      if (IS_LANDING && firstLoad && !el("gdj-acoll-hits").querySelector("li")) hideGrid();
      console.error("[gdj-search] fetch failed", e);
    } finally { state.loading = false; setBusy(false); }
  }

  // ---------------- hits ----------------
  const heart = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.2 8.6 1.7 5 5.1 5c2 0 3.3 1.1 3.9 2.2C9.6 6.1 10.9 5 12.9 5c3.4 0 4.9 3.6 3.1 6.8C19.5 16.1 12 21 12 21z" fill="currentColor"/></svg>';
  const cartSvg = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6h15l-2 9H8L6 6zm0 0L5 3H2m6 15a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  function starsHtml(rating, count) {
    const r = Math.round(Number(rating) * 2) / 2; if (!r) return "";
    let s = '<div class="gdj-card__stars" aria-label="' + r + '/5">';
    for (let i = 1; i <= 5; i++) s += '<span class="gdj-star' + (i <= r ? " is-full" : (i - 0.5 === r ? " is-half" : "")) + '">★</span>';
    s += count ? '<span class="gdj-card__rcount">(' + count + ")</span>" : "";
    return s + "</div>";
  }

  function cardHtml(p) {
    const img = (p.images && p.images[0] && p.images[0].url) || (p.variants && p.variants[0] && p.variants[0].image) || "";
    const onSale = p.special_price != null && p.regular_price != null && Number(p.special_price) < Number(p.regular_price);
    const url = root_url + "products/" + esc(p.handle);
    const pid = numId(p.id);
    const sku = (p.variants && p.variants[0] && p.variants[0].sku) ? String(p.variants[0].sku).trim() : "";
    const brand = p.brand || "";
    const price = onSale
      ? '<span class="gdj-card__price-sale">' + fmtMoney(p.special_price) + '</span> <s class="gdj-card__price-was">' + fmtMoney(p.regular_price) + "</s>"
      : "<span>" + fmtMoney(p.special_price != null ? p.special_price : p.regular_price) + "</span>";
    const ratingHtml = SHOW_RATINGS ? starsHtml(p.rating, p.rating_count) : "";
    const badges =
      (p.is_preorder ? '<span class="gdj-card__badge gdj-card__badge--preorder">' + esc(L.preorder || "Précommande") + "</span>" : "") +
      (p.display_label ? '<span class="gdj-card__badge">' + esc(p.display_label) + "</span>" : "") +
      (onSale ? '<span class="gdj-card__badge">' + esc(L.sale || "Promo") + "</span>" : "");
    return '<article class="gdj-card gdj-card--list" data-product-id="' + esc(pid) + '" data-product-handle="' + esc(p.handle) + '">' +
      '<div class="gdj-card__media-wrap"><div class="gdj-card__corner">' + badges +
      '<span class="gdj-card__pill gdj-card__pill--seen" data-gdj-seenpill hidden>' + esc(L.seen || "Vu") + "</span>" +
      '<span class="gdj-card__pill gdj-card__pill--fav" data-gdj-favpill hidden>' + heart + esc(L.in_favorites || "") + "</span></div>" +
      '<span class="gdj-card__incart" data-gdj-incart hidden><span class="gdj-card__incart-x">&times;</span><b data-gdj-incart-qty>1</b></span>' +
      '<a href="' + url + '" class="gdj-card__media" aria-label="' + esc(p.title) + '" data-gdj-hit="' + esc(pid) + '">' +
      (img ? '<img class="gdj-card__img" src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</a>" +
      '<button type="button" class="gdj-card__fav" data-fav-btn="' + esc(pid) + '" data-fav-handle="' + esc(p.handle) + '" aria-label="' + esc(L.wishlist || "") + '">' + heart + "</button></div>" +
      '<div class="gdj-card__body">' + ratingHtml +
      '<a href="' + url + '" class="gdj-card__title">' + esc(p.title) + "</a>" +
      (sku ? '<div class="gdj-card__sku">' + esc(L.sku || "Réf.") + " " + esc(sku) + "</div>" : "") +
      '<div class="gdj-card__price">' + price + "</div>" +
      '<button type="button" class="gdj-card__quick" data-gdj-quick-add="' + esc(p.handle) + '"' + (p.pickup_only ? ' data-pickup-only="true"' : '') + ">" + cartSvg + "<span>" + esc(p.is_preorder ? (L.preorder || "Précommande") : (L.quick_add || "Ajouter")) + "</span></button>" +
      "</div></article>";
  }

  // --- "Disponible pour ramassage immédiat" -------------------------------
  // The engine places the shopper from their IP (city-level) and tells us the
  // nearest store; we then ask which of THESE results are on that store's
  // shelves. Both calls are best-effort and out of the render path: if either
  // fails, or the shopper is nowhere near a shop, the band simply never appears.
  const PICKUP_KEY = "gdj_pickup_store";      // per session: what the IP suggested
  const FAV_KEY = "gdj_fav_store";           // kept for good: what the shopper chose
  const PICKUP_TTL_MS = 6 * 60 * 60 * 1000;

  function favStore() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || "null"); } catch (_) { return null; }
  }

  function setFavStore(store) {
    try {
      if (store) localStorage.setItem(FAV_KEY, JSON.stringify(store));
      else localStorage.removeItem(FAV_KEY);
    } catch (_) { /* private mode: the choice lasts for this page only */ }
  }

  async function nearbyStore() {
    // A store the shopper picked outranks the one their IP suggests — they know
    // where they shop better than a geolocation database does, and the choice
    // has to survive them travelling.
    const chosen = favStore();
    if (chosen && chosen.location_id) return chosen;

    try {
      const cached = JSON.parse(sessionStorage.getItem(PICKUP_KEY) || "null");
      if (cached && Date.now() - cached.at < PICKUP_TTL_MS) return cached.store;
    } catch (_) { /* private mode: just ask again */ }
    try {
      const res = await fetch(`${API}/api/v1/pickup/nearest?shop=${encodeURIComponent(SHOP)}`);
      if (!res.ok) return null;
      const store = (await res.json()).store || null;
      try { sessionStorage.setItem(PICKUP_KEY, JSON.stringify({ at: Date.now(), store })); } catch (_) { /* ignore */ }
      return store;
    } catch (_) { return null; }
  }

  let storeListCache = null;
  async function allStores() {
    if (storeListCache) return storeListCache;
    try {
      const res = await fetch(`${API}/api/v1/pickup/stores?shop=${encodeURIComponent(SHOP)}`);
      storeListCache = res.ok ? ((await res.json()).stores || []) : [];
    } catch (_) { storeListCache = []; }
    return storeListCache;
  }

  // Swaps the store name for a picker. Choosing writes the favourite and
  // re-renders the band against the products already on screen.
  async function openStorePicker(current) {
    const band = el("gdj-pickup-band");
    const slot = band && band.querySelector(".gdj-pickup__store");
    if (!slot) return;
    const stores = await allStores();
    if (!stores.length) return;

    const auto = L.pickup_auto || "Près de moi (auto)";
    slot.innerHTML =
      '<select class="gdj-pickup__select" aria-label="' + esc(L.pickup_change || "Changer de magasin") + '">' +
      stores.map((st) =>
        '<option value="' + esc(st.location_id) + '"' +
        (current && st.location_id === current.location_id ? " selected" : "") +
        ">" + esc(st.name) + "</option>").join("") +
      '<option value="">' + esc(auto) + "</option></select>";

    const sel = slot.querySelector("select");
    sel.focus();
    sel.addEventListener("change", () => {
      const picked = stores.find((st) => st.location_id === sel.value) || null;
      setFavStore(picked);
      if (!picked) {
        // Back to automatic: drop the session answer so the IP is asked again.
        try { sessionStorage.removeItem(PICKUP_KEY); } catch (_) { /* ignore */ }
      }
      renderPickupBand(state.lastProducts || []);
    });
  }

  async function renderPickupBand(products) {
    const band = el("gdj-pickup-band");
    if (!band) return;
    band.hidden = true;
    band.innerHTML = "";
    if (!products.length) return;

    state.lastProducts = products;   // so a store change can redraw without a refetch
    const store = await nearbyStore();
    if (!store) return;

    let ids = [];
    try {
      const res = await fetch(`${API}/api/v1/pickup/availability`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          shop: SHOP,
          location_id: store.location_id,
          product_ids: products.slice(0, 24).map((p) => p.id),
        }),
      });
      if (!res.ok) return;
      ids = (await res.json()).available || [];
    } catch (_) { return; }
    if (!ids.length) return;

    const inStore = new Set(ids.map(String));
    const picks = products.filter((p) => inStore.has(String(p.id))).slice(0, 6);
    if (!picks.length) return;

    const title = L.pickup_title || "Disponible pour ramassage immédiat";
    const at = L.pickup_at || "en magasin à";
    band.innerHTML =
      '<div class="gdj-pickup__head"><p class="gdj-pickup__title">⚡ ' + esc(title) + "</p>" +
      '<span class="gdj-pickup__store">' + esc(at) + " " + esc(store.name) + "</span>" +
      '<button type="button" class="gdj-pickup__change" data-gdj-store-change>' +
      esc(L.pickup_change || "Changer") + "</button></div>" +
      '<div class="gdj-pickup__scroller">' + picks.map(cardHtml).join("") + "</div>";
    band.hidden = false;
    const changeBtn = band.querySelector("[data-gdj-store-change]");
    if (changeBtn) changeBtn.addEventListener("click", () => openStorePicker(store));
  }

  function appendHits(products) {
    const host = el("gdj-acoll-hits");
    let list = host.querySelector(".ais-InfiniteHits-list");
    if (!list) { host.innerHTML = '<ul class="ais-InfiniteHits-list"></ul>'; list = host.querySelector(".ais-InfiniteHits-list"); }
    if (state.page === 1 && !products.length) {
      const tpl = el("gdj-acoll-empty-tpl");
      if (SEARCH_MODE && tpl && tpl.content) {
        // Designed empty state: message + popular products (server-rendered).
        host.innerHTML = "";
        host.appendChild(tpl.content.cloneNode(true));
        // Word suggestions from the engine, when provided.
        const suggests = (state.facets && state.facets.suggestions) || [];
        const box = host.querySelector("[data-gdj-empty-suggests]");
        if (box && Array.isArray(suggests) && suggests.length) {
          box.innerHTML = suggests.slice(0, 6).map((s) =>
            '<a class="gdj-ac__suggest" href="' + root_url + "search?q=" + encodeURIComponent(s) + '&type=product">' + esc(s) + "</a>"
          ).join("");
          box.hidden = false;
        }
        // Hydrate the popular-product cards (favorites/seen/in-cart pills).
        document.dispatchEvent(new CustomEvent("gdj:cards-added"));
      } else {
        host.innerHTML = '<p class="gdj-acoll__empty">' + esc(L.no_results || "Aucun résultat.") + "</p>";
      }
      return;
    }
    const frag = document.createElement("div");
    frag.innerHTML = products.map((p) => "<li>" + cardHtml(p) + "</li>").join("");
    while (frag.firstChild) list.appendChild(frag.firstChild);
    // fire the theme's card hydration (favorites/seen/in-cart pills) if present
    document.dispatchEvent(new CustomEvent("gdj:cards-added"));
    list.querySelectorAll("[data-gdj-hit]").forEach((a) => {
      if (a.__wired) return; a.__wired = 1;
      a.addEventListener("click", () => trackView(a.getAttribute("data-gdj-hit")));
    });
  }

  // ---------------- facets ----------------
  function facetOptionsHtml(key, options) {
    const sel = state.list[key] || [];
    return options.map((o) => {
      const on = sel.includes(o.value);
      return '<li class="ais-RefinementList-item">' +
        '<label class="ais-RefinementList-label"><input type="checkbox" class="ais-RefinementList-checkbox" data-facet-key="' + esc(key) + '" value="' + esc(o.value) + '"' + (on ? " checked" : "") + ">" +
        '<span class="ais-RefinementList-labelText">' + esc(o.value) + "</span>" +
        '<span class="ais-RefinementList-count">' + o.count + "</span></label></li>";
    }).join("");
  }

  // `searchable` is set when the engine reports more distinct values than it
  // returned (total_values > options.length, i.e. the facet's max_values cap hit).
  // The box queries the engine — the extra values are NOT in the page payload.
  //
  // `key` is the DOM/state key the checkbox handler expects; `searchKey` is the
  // key the ENGINE knows. They differ for product_type (state "__type" vs engine
  // "__product_type"), so don't collapse them.
  function listFacetHtml(key, options, searchable, searchKey) {
    const box = searchable
      ? '<input type="search" class="ais-SearchBox-input" data-facet-search="' + esc(searchKey || key) + '"' +
        ' data-facet-target="' + esc(key) + '"' +
        ' placeholder="' + esc(L.brand_search || "Rechercher…") + '" autocomplete="off">'
      : "";
    return box + '<ul class="ais-RefinementList-list">' + facetOptionsHtml(key, options) + "</ul>";
  }

  // Debounced server-side facet value search -> swap just the <ul> so the input
  // keeps focus/caret while typing.
  const facetSearchTimers = {};
  function onFacetSearch(input) {
    const key = input.getAttribute("data-facet-search");          // engine key
    const target = input.getAttribute("data-facet-target") || key; // DOM/state key
    clearTimeout(facetSearchTimers[key]);
    facetSearchTimers[key] = setTimeout(async () => {
      const list = input.parentNode && input.parentNode.querySelector(".ais-RefinementList-list");
      if (!list) return;
      try {
        const res = await fetch(`${API}/api/v1/facet-values`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            shop: SHOP, key, q: input.value, query: state.q,
            locale: LOCALE, filters: buildFilters(),
          }),
        });
        if (!res.ok) return;
        const data = await res.json();
        // Render with the DOM/state key so the checkbox handler still matches.
        // type/brand keep their selections outside state.list — mirror them in
        // briefly (same trick renderFacets uses) so checked boxes stay checked.
        const orig = state.list[target];
        if (target === "__type") state.list.__type = state.type;
        else if (target === "__brand") state.list.__brand = state.brand;
        list.innerHTML = facetOptionsHtml(target, data.options || []);
        state.list[target] = orig;
      } catch (_) { /* leave the current list in place */ }
    }, 200);
  }

  // The engine counts every facet INSIDE the current selection, so once « Casse-tête
  // adultes » was ticked it was the only category left to pick: multi-select in name
  // only (team 2026-10-09). A list facet with something ticked is therefore redrawn
  // from POST /api/v1/facet-values, which leaves that facet's OWN selection out of the
  // scope while every other filter still applies, so the counts stay truthful.
  const facetCap = {};   // DOM key -> how many options the engine lists while none is ticked
  let facetGen = 0;      // bumped per fresh result set; a late answer for an older one is dropped

  // f: { box, key (DOM/state key), engineKey, sel (ticked values), opts, total, builtin }
  function drawList(box, f, opts, searchable) {
    // facetOptionsHtml reads the checked state from state.list — mirror the selection in.
    const had = Object.prototype.hasOwnProperty.call(state.list, f.key), orig = state.list[f.key];
    state.list[f.key] = f.sel;
    box.innerHTML = opts.length ? listFacetHtml(f.key, opts, searchable, f.engineKey) : "";
    if (had) state.list[f.key] = orig; else delete state.list[f.key];
    box.closest(".gdj-acoll__facet")?.classList.toggle("is-empty", !opts.length);
  }

  function renderList(f, canWiden, gen) {
    const box = el(f.box); if (!box) return;
    // Engine caps options at the facet's max_values; offer the search box when
    // there are more values than it sent.
    const searchable = f.total > f.opts.length;
    if (!f.sel.length) facetCap[f.key] = searchable ? f.opts.length : 100;
    const widen = canWiden && f.sel.length > 0 && !(f.engineKey in LOCKED);
    // While the full list loads, keep the one on screen (it holds the box the shopper
    // just ticked) rather than flashing down to the ticked values alone.
    if (!(widen && box.querySelector(".ais-RefinementList-list"))) drawList(box, f, f.opts, searchable);
    if (widen) widenList(box, f, searchable, gen);
  }

  async function widenList(box, f, searchable, gen) {
    const limit = facetCap[f.key] || (f.builtin ? 30 : 10);
    let opts = null;
    try {
      const res = await fetch(`${API}/api/v1/facet-values`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: SHOP, key: f.engineKey, q: "", query: state.q, locale: LOCALE, filters: buildFilters(), limit }),
      });
      if (res.ok) opts = ((await res.json()).options || []).map((o) => ({ value: o.value, count: o.count }));
    } catch (_) { /* keep the engine's own list below */ }
    if (gen !== facetGen) return;   // a newer result set is already on screen
    if (!opts) { drawList(box, f, f.opts, searchable); return; }
    // A ticked value always stays listed, so it can be unticked.
    f.sel.forEach((v) => {
      if (!opts.some((o) => o.value === v)) opts.push(f.opts.find((o) => o.value === v) || { value: v, count: 0 });
    });
    drawList(box, f, opts, searchable || opts.length >= limit);
  }

  function renderFacets(data) {
    const gen = ++facetGen;
    // Filters inferred from the typed words and fuzzy/semantic rescues are applied
    // inside the search route only; facet-values can't rebuild that scope, so those
    // result sets keep the engine's own lists.
    const canWiden = !(state.autoFilters || []).length && !data.fuzzy_added && !data.semantic_added;
    const builtin = (rows) => ({ opts: (rows || []).map((r) => ({ value: r.value, count: r.count })), total: Number((rows || [])[0]?.total_values || 0) });
    const lists = [];

    // Type facet (Shopify product_type). A cat- collection page IS its category: the
    // facet could only ever list that one value, so it is hidden there (team 2026-10-09).
    if (CATEGORY) {
      const typeC = el("gdj-facet-type");
      if (typeC) { typeC.innerHTML = ""; typeC.closest(".gdj-acoll__facet")?.classList.add("is-empty"); }
    } else {
      lists.push(Object.assign({ box: "gdj-facet-type", key: "__type", engineKey: "__product_type", sel: state.type, builtin: true }, builtin(data.type_facets)));
    }
    // Brand facet (engine-native, vendor-fallback) -> #gdj-facet-vendor
    lists.push(Object.assign({ box: "gdj-facet-vendor", key: "__brand", engineKey: "__brand", sel: state.brand, builtin: true }, builtin(data.brand_facets)));

    // Other list metafield facets -> mapped containers (theme/color)
    const byKey = {};
    (data.list_facets || []).forEach((f) => { byKey[f.metafield_key] = f; });
    ["theme", "color"].forEach((slot) => {
      const key = FMAP[slot]; if (!key) return;
      const f = byKey[key];
      lists.push({
        box: "gdj-facet-" + slot, key, engineKey: key, sel: state.list[key] || [],
        opts: f ? f.options.map((o) => ({ value: o.value, count: o.count })) : [],
        total: f ? Number(f.total_values || 0) : 0,
      });
    });
    lists.forEach((f) => renderList(f, canWiden, gen));

    // Price slider (engine price_facet)
    if (data.price_facet) buildSlider("price", data.price_facet.min, data.price_facet.max, 0, (v) => fmtMoney(v), "__price", true);

    // Numeric metafield sliders (players/age) from slider_facets
    const sByKey = {};
    (data.slider_facets || []).forEach((s) => { sByKey[s.metafield_key] = s; });
    // players / age / duration all come from hub.* numeric metafields. They only
    // arrive as sliders when the filter row has BOTH ui_type slider_* AND
    // is_numeric = true - the admin sets only the first, which is why sliders
    // never appeared (team 2026-08-29).
    ["players", "age", "duration"].forEach((slot) => {
      const key = FMAP[slot]; const s = key && sByKey[key];
      const box = el("gdj-facet-" + slot);
      if (box) box.closest(".gdj-acoll__facet")?.classList.toggle("is-empty", !s);
      if (!s) return;
      const fmt = slot === "players" ? (v) => Math.round(v) + " " + (L.players_unit || "j.")
                : slot === "duration" ? (v) => Math.round(v) + " " + (L.minutes_unit || "min")
                : ageLabel;
      buildSlider(slot, s.min, s.max, slot === "age" ? 1 : 0, fmt, key, false);
    });
  }

  function ageLabel(v) { const n = Number(v); return n < 1 ? Math.round(n * 12) + " " + (L.months_unit || "mo") : Math.round(n) + " " + (L.years_unit || "an"); }

  function buildSlider(slot, min, max, decimals, fmt, filterKey, isPrice) {
    const box = el("gdj-facet-" + slot);
    if (!box || min == null || max == null || min === max || typeof noUiSlider === "undefined") return;
    if (box.__slider) return; // already built this cycle
    // Facets start hidden (no flash of seven headings), so a slider that builds
    // successfully has to reveal its own container.
    box.closest(".gdj-acoll__facet")?.classList.remove("is-empty");
    box.innerHTML = '<div class="gdj-slider"></div><div class="gdj-slider__io">' +
      '<label class="gdj-slider__io-field"><span>' + esc(L.range_from || "Min") + '</span><input type="number" data-io="min"></label>' +
      '<label class="gdj-slider__io-field"><span>' + esc(L.range_to || "Max") + '</span><input type="number" data-io="max"></label></div>';
    const cur = isPrice ? state.price : state.sliders[filterKey];
    const start = [cur ? cur.min : min, cur ? cur.max : max];
    const sl = box.querySelector(".gdj-slider");
    noUiSlider.create(sl, { start, connect: true, range: { min: Number(min), max: Number(max) }, step: decimals ? 0.5 : 1 });
    box.__slider = sl;
    const inMin = box.querySelector('[data-io="min"]'), inMax = box.querySelector('[data-io="max"]');
    sl.noUiSlider.on("update", (vals) => { inMin.value = Math.round(vals[0] * (decimals ? 10 : 1)) / (decimals ? 10 : 1); inMax.value = Math.round(vals[1] * (decimals ? 10 : 1)) / (decimals ? 10 : 1); });
    sl.noUiSlider.on("change", (vals) => {
      const val = { min: Number(vals[0]), max: Number(vals[1]) };
      if (isPrice) state.price = val; else state.sliders[filterKey] = val;
      fetchPage(true);
    });
    const applyIO = () => { const v = { min: Number(inMin.value), max: Number(inMax.value) }; sl.noUiSlider.set([v.min, v.max]); if (isPrice) state.price = v; else state.sliders[filterKey] = v; fetchPage(true); };
    inMin.addEventListener("change", applyIO); inMax.addEventListener("change", applyIO);
  }

  // facet checkbox changes (delegated)
  // Per-facet value search (delegated: the inputs are re-rendered on each fetch).
  root.addEventListener("input", (e) => {
    const box = e.target.closest("[data-facet-search]");
    if (box) onFacetSearch(box);
  });

  root.addEventListener("change", (e) => {
    const cb = e.target.closest(".ais-RefinementList-checkbox"); if (!cb) return;
    const key = cb.getAttribute("data-facet-key"); const val = cb.value;
    if (key === "__type") {
      state.type = cb.checked ? [...state.type, val] : state.type.filter((x) => x !== val);
    } else if (key === "__brand") {
      state.brand = cb.checked ? [...state.brand, val] : state.brand.filter((x) => x !== val);
    } else {
      if (!state.list[key]) state.list[key] = [];
      state.list[key] = cb.checked ? [...state.list[key], val] : state.list[key].filter((x) => x !== val);
    }
    // reset slider "built" flags so they rebuild against the new result set
    ["price", "players", "age"].forEach((s) => { const b = el("gdj-facet-" + s); if (b) b.__slider = null; });
    fetchPage(true);
  });

  // ---------------- toolbar (stats / sort / current / clear) ----------------
  function renderToolbar() {
    const stats = el("gdj-acoll-stats");
    if (stats) stats.textContent = state.total + " " + (L.products || "produits");
    if (moreBtn) { moreBtn.disabled = false; moreBtn.hidden = state.done || !state.total; }

    const sortC = el("gdj-acoll-sort");
    if (sortC && !sortC.__built) {
      sortC.__built = 1;
      // "En vedette" is gone (team 2026-08-28): searches expose it as
      // "Pertinence" (relevance drives result order); collection pages have
      // no query, so the option is dropped entirely there.
      const featuredOpt = SEARCH_MODE
        ? '<option value="featured">' + esc(L.sort_relevance || "Pertinence") + "</option>"
        : "";
      sortC.innerHTML = '<span class="gdj-acoll__sortlabel">' + esc(L.sort_label || "Classer par") + "</span>" +
        '<select class="ais-SortBy-select">' + featuredOpt +
        '<option value="price_asc">' + esc(L.sort_price_asc || "Prix croissant") + "</option>" +
        '<option value="price_desc">' + esc(L.sort_price_desc || "Prix décroissant") + "</option>" +
        '<option value="best_sellers">' + esc(L.sort_best || "Meilleures ventes") + "</option>" +
        '<option value="newest">' + esc(L.sort_newest || "Nouveaux produits") + "</option></select>";
      const sel = sortC.querySelector("select");
      sel.value = state.sort;
      if (sel.value !== state.sort) { state.sort = sel.options[0].value; sel.value = state.sort; }
      sel.addEventListener("change", (e) => { state.sort = e.target.value; fetchPage(true); });
    }

    renderCurrent();
  }

  // metafield key -> the slot it is rendered in, so a chip can name its filter.
  const SLOT_BY_KEY = {};
  Object.keys(FMAP).forEach((slot) => { SLOT_BY_KEY[FMAP[slot]] = slot; });
  // "1–8" tells a shopper nothing about WHICH filter they set, and with age and
  // players both active the two pills were indistinguishable. Always name it.
  // The heading the shopper reads above the facet itself ("Âge", "Joueurs") is
  // the only name that will match what they clicked, and it is already
  // translated by the section.
  function slotLabel(slot) {
    const box = el("gdj-facet-" + slot);
    const head = box && box.closest(".gdj-acoll__facet");
    const span = head && head.querySelector(".gdj-acoll__facet-head span");
    return span ? span.textContent.trim() : "";
  }
  function facetName(key, fallback) {
    if (key === "__product_type" || key === "__type") return slotLabel("type") || "Type";
    if (key === "__brand") return slotLabel("vendor") || "Marque";
    if (key === "__price") return slotLabel("price") || "Prix";
    if (key === "__tag") return slotLabel("type") || "Type";
    if (key === "__age") return slotLabel("age") || "Âge";
    const slot = SLOT_BY_KEY[key];
    // fallback: the engine's own display label, for a filter the theme has no
    // slot for (auto-applied metafields).
    return (slot && (L[slot] || slotLabel(slot))) || fallback
      || String(key).split(".").pop().replace(/[_-]+/g, " ");
  }
  const named = (key, value, fallback) => facetName(key, fallback) + " : " + value;

  function chips() {
    const out = [];
    // A cat- page's own category is the page, not a filter: no pill for it (its facet is hidden too).
    state.type.forEach((v) => { if (v !== CATEGORY) out.push({ label: named("__type", v), clear: () => { state.type = state.type.filter((x) => x !== v); } }); });
    if (state.brand.length) state.brand.forEach((v) => out.push({ label: named("__brand", v), clear: () => { state.brand = state.brand.filter((x) => x !== v); } }));
    Object.entries(state.list).forEach(([k, vals]) => (vals || []).forEach((v) => out.push({ label: named(k, v), clear: () => { state.list[k] = state.list[k].filter((x) => x !== v); } })));
    Object.keys(state.sliders).forEach((k) => out.push({ label: named(k, state.sliders[k].min + "–" + state.sliders[k].max), clear: () => { delete state.sliders[k]; } }));
    if (state.price) out.push({ label: named("__price", fmtMoney(state.price.min) + "–" + fmtMoney(state.price.max)), clear: () => { state.price = null; } });
    // Filters the ENGINE inferred from the words typed ("7 wonders extension"
    // -> tag: extension). Shown so the narrowing is never invisible, and
    // removable: clearing one turns extraction off for the next request.
    (state.autoFilters || []).forEach((a) => out.push({
      // `display` is what the shopper typed ("5 ans"); `value` is what the engine
      // filters on (the number 5).
      label: "✨ " + named(a.key, a.display || a.value, a.name),
      clear: () => { state.noAutoFacets = true; state.autoFilters = []; },
    }));
    return out;
  }

  function renderCurrent() {
    const c = el("gdj-acoll-current"); if (!c) return;
    const cs = chips();
    c.innerHTML = '<ul class="ais-CurrentRefinements-list">' + cs.map((x, i) =>
      '<li class="ais-CurrentRefinements-category"><span>' + esc(x.label) + '</span><button class="ais-CurrentRefinements-delete" data-chip="' + i + '">×</button></li>').join("") + "</ul>";
    c.querySelectorAll("[data-chip]").forEach((b) => b.addEventListener("click", () => {
      cs[Number(b.dataset.chip)].clear();
      ["price", "players", "age"].forEach((s) => { const bx = el("gdj-facet-" + s); if (bx) bx.__slider = null; });
      fetchPage(true);
    }));
    const clr = el("gdj-acoll-clear");
    if (clr) {
      clr.innerHTML = cs.length ? '<button class="ais-ClearRefinements-button">' + esc(L.clear || "Tout effacer") + "</button>" : "";
      const btn = clr.querySelector("button");
      if (btn) btn.addEventListener("click", () => { state.list = {}; state.sliders = {}; state.price = null; state.type = CATEGORY ? [CATEGORY] : []; state.brand = []; ["price", "players", "age"].forEach((s) => { const bx = el("gdj-facet-" + s); if (bx) bx.__slider = null; }); fetchPage(true); });
    }
    const cnt = root.querySelector("[data-acoll-count]");
    if (cnt) { cnt.textContent = cs.length; cnt.hidden = !cs.length; }
  }

  // ---------------- load more (explicit button, no auto-load on scroll) ----------------
  const sentinel = root.querySelector("[data-acoll-sentinel]");
  let moreBtn = null;
  if (sentinel) {
    moreBtn = document.createElement("button");
    moreBtn.type = "button";
    moreBtn.className = "gdj-acoll__more";
    moreBtn.textContent = L.load_more || "Voir plus de produits";
    moreBtn.hidden = true;
    const spin = document.createElement("div");
    spin.className = "gdj-acoll__spinner";
    spin.hidden = true;
    sentinel.appendChild(spin);
    sentinel.appendChild(moreBtn);
    moreBtn.addEventListener("click", () => {
      if (state.loading || state.done) return;
      moreBtn.disabled = true;
      state.page += 1;
      fetchPage(false);
    });
  }

  // ---------------- facet accordion + mobile drawer ----------------
  root.addEventListener("click", (e) => {
    const head = e.target.closest("[data-facet-toggle]");
    if (head) { head.closest(".gdj-acoll__facet").classList.toggle("is-open"); return; }
    if (e.target.closest("[data-acoll-open]")) { openDrawer(true); return; }
    if (e.target.closest("[data-acoll-close]") || e.target.closest("[data-acoll-overlay]")) openDrawer(false);
  });
  // Landing pages can stack several grids: each floating « Filtres » button shows only while
  // its own grid is on screen (collection/search pages keep their single, always-on button).
  if (IS_LANDING && "IntersectionObserver" in window) {
    root.classList.add("gdj-acoll--offscreen");
    new IntersectionObserver((entries) => {
      root.classList.toggle("gdj-acoll--offscreen", !entries[0].isIntersecting);
    }).observe(root);
  }
  function openDrawer(open) {
    const dr = root.querySelector("[data-acoll-drawer]"); const ov = root.querySelector("[data-acoll-overlay]");
    if (dr) dr.setAttribute("aria-hidden", open ? "false" : "true");
    if (ov) ov.hidden = !open;
    document.body.classList.toggle("gdj-acoll-locked", open);
  }

  // ---------------- back/forward scroll restoration ----------------
  // The grid is rendered client-side, so on back-navigation the browser has
  // nothing to scroll to and lands at the top. Persist the listing state +
  // scroll offset per URL and rebuild before scrolling back.
  const RESTORE_KEY = "gdj_acoll_pos:" + location.pathname + location.search + ":" + (d.gridKey || "main");
  const RESTORE_TTL = 30 * 60 * 1000;
  const MAX_RESTORE_ITEMS = 240;

  // On desktop (≥990px) Horizon scrolls inside .page-wrapper and the window never moves
  // (assets/scroll-container.js); on mobile the window scrolls. Reading/writing only the
  // window lost the position on desktop: Horizon's own restore runs at pageshow, before
  // the products are loaded, so it lands on a page that is still too short.
  const pageWrapper = document.querySelector(".page-wrapper");
  function pageY() { return Math.max(pageWrapper ? pageWrapper.scrollTop : 0, window.scrollY || 0); }
  function scrollPageTo(y) {
    // "instant" overrides the CSS scroll-behavior: smooth on html and .page-wrapper.
    if (pageWrapper) pageWrapper.scrollTo({ top: y, behavior: "instant" });
    window.scrollTo({ top: y, behavior: "instant" });
  }

  function saveListingPos() {
    try {
      sessionStorage.setItem(RESTORE_KEY, JSON.stringify({
        y: pageY(),
        pages: state.page,
        sort: state.sort,
        q: state.q,
        list: state.list,
        sliders: state.sliders,
        price: state.price,
        type: state.type,
        brand: state.brand,
        t: Date.now(),
      }));
    } catch (_) {}
  }
  let saveTimer;
  // Capture phase: scroll events don't bubble, and this catches both the window (mobile)
  // and .page-wrapper (desktop).
  document.addEventListener("scroll", () => {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveListingPos, 250);
  }, { capture: true, passive: true });
  window.addEventListener("pagehide", saveListingPos);

  function loadListingPos() {
    const saved = safeJson(sessionStorage.getItem(RESTORE_KEY), null);
    if (!saved || Date.now() - (saved.t || 0) > RESTORE_TTL) return null;
    return saved;
  }

  async function restoreListing(saved) {
    state.sort = saved.sort || state.sort;
    state.q = saved.q != null ? saved.q : state.q;
    state.list = saved.list || {};
    state.sliders = saved.sliders || {};
    state.price = saved.price || null;
    state.type = saved.type && saved.type.length ? saved.type : state.type;
    state.brand = saved.brand || [];
    const pages = Math.max(1, Math.min(Number(saved.pages) || 1, Math.ceil(MAX_RESTORE_ITEMS / PER_PAGE)));
    state.loading = true;
    try {
      // One bulk request instead of replaying N infinite-scroll pages.
      const res = await fetch(`${API}/api/v1/search`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: SHOP, q: state.q, locale: LOCALE, filters: buildFilters(), sort: state.sort, page: 1, limit: pages * PER_PAGE, session_id: sessionId, disable_auto_facets: !!state.noAutoFacets }),
      });
      const data = await res.json();
      const raw = data.products || [];
      const products = raw.filter(passesMust);
      state.total = Math.max(0, (data.total || 0) - (raw.length - products.length));
      state.facets = data;
      state.page = pages;
      const pins = PINNED.length ? await fetchPinned() : [];
      state.total += pins.length;
      el("gdj-acoll-hits").innerHTML = "";
      appendHits(pins.concat(products));
      firstLoad = false;
      if (pages * PER_PAGE >= (data.total || 0) || raw.length === 0) state.done = true;
      renderFacets(data);
      renderToolbar();
      state.loading = false;
      setBusy(false);
      const y = Number(saved.y) || 0;
      // Card media boxes have fixed aspect ratios, so layout height is stable
      // as soon as the DOM is in — a couple of frames is enough.
      requestAnimationFrame(() => requestAnimationFrame(() => scrollPageTo(y)));
    } catch (e) {
      state.loading = false;
      setBusy(false);
      console.error("[gdj-search] restore failed", e);
      fetchPage(true);
    }
  }

  // ---------------- go ----------------
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  // Restore ONLY on back/forward (and reload) — a fresh click on a nav link
  // to the same collection must start at the top.
  const navEntry = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  const cameBack = navEntry ? (navEntry.type === "back_forward" || navEntry.type === "reload") : false;
  const savedPos = cameBack ? loadListingPos() : null;
  if (!cameBack) { try { sessionStorage.removeItem(RESTORE_KEY); } catch (_) {} }
  if (savedPos) {
    restoreListing(savedPos);
  } else {
    fetchPage(true);
  }
  } // end initGrid
  document.querySelectorAll(".gdj-acoll").forEach(initGrid);
})();
